import * as React from "react"

const RweInfos = (props) => (
    <svg
        id={""}
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <path
            d="M265 245c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.147-45 45 20.147 45 45 45Z"
            fill="#2D1552"
        />
        <path
            d="M265 244c24.301 0 44-19.699 44-44s-19.699-44-44-44-44 19.699-44 44 19.699 44 44 44Z"
            stroke="#DEDDE2"
            strokeWidth={2}
        />
        <text
            fill="#FAFAFA"
            xmlSpace="preserve"
            style={{
                whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={10}
            letterSpacing="0em"
        >
            <tspan x={226.412} y={204.5}>
                {props.lang === "es" ? "PROFESIONALES": "PROFESSIONALS"}
            </tspan>
        </text>
        <path
            d="M558.227 239c24.978 0 45.227-20.147 45.227-45s-20.249-45-45.227-45C533.249 149 513 169.147 513 194s20.249 45 45.227 45Z"
            fill="#2D1552"
        />
        <path
            d="M558.227 238c24.426 0 44.227-19.699 44.227-44s-19.801-44-44.227-44S514 169.699 514 194s19.801 44 44.227 44Z"
            stroke="#DEDDE2"
            strokeWidth={2}
        />
        <text
            fill="#FAFAFA"
            xmlSpace="preserve"
            style={{
                whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={10}
            letterSpacing="0em"
        >
            <tspan x={528.086} y={199}>
                {props.lang === 'es'? "COMPA\xD1\xCDAS": "COMPANIES"}
            </tspan>
        </text>
        <path
            d="M684 465c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.147-45 45 20.147 45 45 45Z"
            fill="#2D1552"
        />
        <path
            d="M684 464c24.301 0 44-19.699 44-44s-19.699-44-44-44-44 19.699-44 44 19.699 44 44 44Z"
            stroke="#DEDDE2"
            strokeWidth={2}
        />
        <text
            fill="#FAFAFA"
            xmlSpace="preserve"
            style={{
                whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={10}
            letterSpacing="0em"
        >
            <tspan x={646.267} y={425}>
                {props.lang === "es" ? "ASOCIACIONES": "ASSOCIATIONS"}
            </tspan>
        </text>
        <path
            d="M548 669c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.147-45 45 20.147 45 45 45Z"
            fill="#2D1552"
        />
        <path
            d="M548 668c24.301 0 44-19.699 44-44s-19.699-44-44-44-44 19.699-44 44 19.699 44 44 44Z"
            stroke="#DEDDE2"
            strokeWidth={2}
        />
        <g fill="#FAFAFA" fontFamily="Poppins" fontSize={10} letterSpacing="0em">
            <text
                xmlSpace="preserve"
                style={{
                    whiteSpace: "pre",
                }}

            >
                <tspan x={530.194} y={638}>
                    {"MAKERS"}
                </tspan>
            </text>
            <text
                xmlSpace="preserve"
                style={{
                    whiteSpace: "pre",
                }}
            >
                <tspan x={534.003} y={623}>
                    {"POLICY\n"}
                </tspan>
            </text>
        </g>
        <path
            d="M288 669c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.147-45 45 20.147 45 45 45Z"
            fill="#2D1552"
        />
        <path
            d="M288 668c24.301 0 44-19.699 44-44s-19.699-44-44-44-44 19.699-44 44 19.699 44 44 44Z"
            stroke="#DEDDE2"
            strokeWidth={2}
        />
        <text
            fill="#FAFAFA"
            xmlSpace="preserve"
            style={{
                whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={10}
            letterSpacing="0em"
        >
            <tspan x={props.lang ==="es"? 248.382: 270} y={629}>
                {props.lang ==="es"? "FINANCIADORES": "PAYERS"}
            </tspan>
        </text>
        <path
            d="M161 465c24.853 0 45-20.147 45-45s-20.147-45-45-45-45 20.147-45 45 20.147 45 45 45Z"
            fill="#2D1552"
        />
        <path
            d="M161 464c24.301 0 44-19.699 44-44s-19.699-44-44-44-44 19.699-44 44 19.699 44 44 44Z"
            stroke="#DEDDE2"
            strokeWidth={2}
        />
        <g fill="#FAFAFA" fontFamily="Poppins" fontSize={10} letterSpacing="0em">
            <text
                xmlSpace="preserve"
                style={{
                    whiteSpace: "pre",
                }}

            >
                <tspan x={props.lang==="es" ? 136.299: 129 } y={433.5}>
                    {props.lang==="es" ?"DE SALUD":"INSTITUTIONS"}
                </tspan>
            </text>
            <text
                xmlSpace="preserve"
                style={{
                    whiteSpace: "pre",
                }}
            >
                <tspan x={props.lang==="es"? 124.268: 130 } y={418.5}>
                    {props.lang==="es"? "INSTITUCIONES\n": "HEALTHCARE\n"}
                </tspan>
            </text>
        </g>
    </svg>
)

export default RweInfos
